import React from 'react';

export function Coach({ row }) {
  const quizz = row;

  return (
    <div className="coach">
      <img src={quizz.coach_thumb} alt={quizz.coach_name}/>
    </div>
  );
}
